import { ReactElement, useEffect } from 'react';
import './Legal.scss';
import { ErrorPage } from '../Error/ErrorPage';
import { PlatformContentFrame } from '../../PlatformContentFrame/PlatformContentFrame';
import { usePlatform, useLegal, useProjectConfig } from '../../ContextProviders/AppContext';
import { localizedStrings } from '../../../localizedStrings';

export const LegalDocument = ({ name }: { name: string }): ReactElement => {
  const platform = usePlatform();
  const legal = useLegal();
  const camelCasedName = name
    .split('-')
    .map((word: string, i) => (i > 0 ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word.toLowerCase()))
    .join('');

  const projectConfig = useProjectConfig();
  useEffect(() => {
    document.title = `${projectConfig.doc.name} | ${localizedStrings.global.termsOfUse}`;
  }, [projectConfig.doc?.name]);

  if (!legal.doc[camelCasedName]) return <ErrorPage error={new Error(localizedStrings.error[404])} />;

  const body = legal.doc[camelCasedName]
    .replace('{{publisher}}', platform.doc.publisher)
    .replace('{{organisation}}', platform.doc.organization)
    .replace('{{application}}', platform.doc.name);

  return <PlatformContentFrame body={body} />;
};
